import { render, staticRenderFns } from "./Message.view.vue?vue&type=template&id=447625d1&"
import script from "./Message.view.vue?vue&type=script&lang=js&"
export * from "./Message.view.vue?vue&type=script&lang=js&"
import style0 from "./Message.view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports